import { AbilityGlyph } from "@/features/matches";

export type Ability = {
  id: number;
  name: string;
  iconUrl: string | null;
  ultimate: boolean;
};

type AbilityIconProps = {
  ability: Ability;
  size?: number;
  // Подпись для экранного диктора там, где названия рядом нет (лента прокачки на телефоне).
  label?: string;
};

// Значок умения, как в игре: белый знак на тёмной плашке, у ульты — золотая рамка.
export const AbilityIcon = ({ ability, size = 30, label }: AbilityIconProps) => (
  <AbilityGlyph
    name={ability.name}
    iconUrl={ability.iconUrl}
    ultimate={ability.ultimate}
    size={size}
    label={label}
  />
);
